import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Input, Button, Form, Alert } from 'antd'
import { Link } from 'react-router-dom'
import style from '../style.module.scss'
import apiClient from '../../../shared/services/axios'
import { emailRule, passwordRule } from '../../../shared/services/validators'
import { Helmet } from 'react-helmet'

const mapStateToProps = ({ user, settings, dispatch }: any) => ({
  dispatch,
  user,
  authProvider: settings.authProvider,
  logo: settings.logo,
})

const Login: React.FC = ({ dispatch, user }: any) => {
  const [sending, setSending] = useState(false)
  const [mailSent, setMailSent] = useState(false)

  const sendMail = () => {
    setSending(true)
    if (user.email) {
      apiClient
        .post(`Merchants/SendEmailConfirmMail`, { email: user.email.toLowerCase() })
        .then(response => {
          if (response.data.success) {
            setMailSent(true)
          }
        })
        .finally(() => setSending(false))
    }
  }

  const onFinish = (values: any) => {
    dispatch({
      type: 'user/LOGIN',
      payload: values,
    })
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <div>
      <Helmet title="Giriş Yap" />
      {user.email && !user.confirm ? (
        <div className={`card ${style.container}`}>
          <div className="text-dark font-size-24 mb-4 text-center">
            <strong>Üyelik Aktivasyonu</strong>
          </div>
          {mailSent ? (
            <Alert
              className="text-center"
              type="success"
              message="Doğrulama kodu e-posta adresinize gönderildi."
            />
          ) : (
            <>
              <Alert
                className="text-center mb-3"
                type="error"
                description={
                  <>
                    <p>
                      Lütfen üyeliğiniz sırasında e-posta adresinize gönderilen bağlantıya
                      tıklayarak doğrulama işlemini tamamlayınız.
                    </p>
                    <p>
                      E-posta ulaşmadıysa aşağıdaki butonu tıklayarak tekrar gönderilmesini
                      sağlayabilirsiniz.
                    </p>
                  </>
                }
                message={
                  <p>
                    <strong>E-posta Adresiniz Doğrulanmamış</strong>
                  </p>
                }
              />
              <Button type="primary" loading={sending} onClick={sendMail}>
                Doğrulama E-postasını Tekrar Gönder
              </Button>
            </>
          )}
          <a
            role="button"
            tabIndex={-1}
            onKeyDown={() => dispatch({ type: 'user/LOGOUT' })}
            className="kit__utils__link font-size-16 mt-4"
            onClick={() => dispatch({ type: 'user/LOGOUT' })}
          >
            <i className="fe fe-arrow-left mr-1 align-middle" /> Giriş Yap
          </a>
        </div>
      ) : (
        <div>
          <div className="text-center mb-5">
            <h1 className="mb-4 px-3">
              <strong>Movell Satıcı Paneline Hoşgeldiniz</strong>
            </h1>
            <p>
              Giriş yaptıktan sonra sol menü üzerinden işlem yapabilirsiniz.
              <br />
              Herhangi bir hatayla karşılaşmanız durumunda. Dilediğiniz zaman;
              <br />
              Bizimle iletişime geçebilirsiniz - <strong>satici@movell.com.tr</strong>
            </p>
          </div>
          <div className={`card ${style.container}`}>
            <div className="text-dark font-size-24 mb-3">
              <strong>Hesabınıza giriş yapın</strong>
            </div>

            <Form
              layout="vertical"
              hideRequiredMark
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="mb-4"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Lütfen e-posta adresinizi giriniz' },
                  emailRule,
                ]}
              >
                <Input size="large" placeholder="Email" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Lütfen şifrenizi giriniz' }, passwordRule]}
              >
                <Input size="large" type="password" placeholder="Password" />
              </Form.Item>
              <Button
                type="primary"
                size="large"
                className="text-center w-100"
                htmlType="submit"
                loading={user.loading}
              >
                <strong>Giriş</strong>
              </Button>
            </Form>
            <div className="row">
              <div className="col-md-5">
                <Link to="/auth/forgot-password" className="kit__utils__link font-size-16">
                  Şifremi Unutttum
                </Link>
              </div>
              <div className="col-md-7 text-right">
                <span className="mr-2 font-size-16">Hesabınız yok mu?</span>
                <Link to="/auth/register" className="kit__utils__link font-size-16">
                  Başvuru Yapın
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default connect(mapStateToProps)(Login)
